import React, { useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { Form } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import config from "../../Config";
import StudentPanelMenu from "./StudentPanelMenu";
import PublicTicketTypeDropDown from "../Support/PublicTicketTypeDropDown";
import SupportFileAttachment from "../Support/SupportFileAttachment";
import { getStudentSupportApiPayload, getSupportApiErrorMessage } from "./studentSupportApiPayload";
import StudentSupportParentGuard from "./StudentSupportParentGuard";

function StudentSupportNewTicket() {
  const navigate = useNavigate();
  const [validated, setValidated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [attachmentString, setAttachmentString] = useState("");
  const attachmentRef = useRef("");

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }

    setLoading(true);
    const attachedImage = attachmentRef.current || attachmentString;
    const data = getStudentSupportApiPayload({
      TicketSource: "Website",
      Subject: event.target.subject.value.trim(),
      Description: event.target.description.value.trim(),
      TicketType: event.target.type.value,
      FileAttached: attachedImage,
      fileAttached: attachedImage,
    });

    axios({
      method: "post",
      url: config.base_url + "Support/AddStudentSupportTicket",
      headers: { "Content-Type": "application/json" },
      data,
    })
      .then((response) => {
        if (response.data.status_code === 1) {
          if (response.data.attachment_saved === false) {
            toast.warn(
              response.data.status_message ||
                "Ticket saved, but the photo could not be attached. Open the ticket and attach it again.",
              { position: toast.POSITION.TOP_RIGHT }
            );
          } else {
            toast.success(response.data.status_message, {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
          navigate("/student-panel/support/tickets");
        } else {
          toast.error(response.data.status_message || "Could not submit ticket.", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        toast.error(getSupportApiErrorMessage(err), {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  return (
    <StudentSupportParentGuard>
      <>
      <ToastContainer />
      <StudentPanelMenu />
      <div className="page-head">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/student-panel/dashboard">Dashboard</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/student-panel/support/tickets">Support</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Raise ticket
              </li>
            </ol>
          </nav>
          <div className="page-title">Raise support ticket</div>
        </div>
      </div>
      <div className="container pb-4">
        <div className="card">
          <div className="card-body p-md-4">
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <div className="row gy-3">
                <div className="col-md-6">
                  <label className="form-label">Subject</label>
                  <input
                    type="text"
                    className="form-control"
                    name="subject"
                    required
                    maxLength={200}
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Department</label>
                  <select className="form-select" name="type" required>
                    <option value="">Select department</option>
                    <PublicTicketTypeDropDown />
                  </select>
                </div>
                <div className="col-12">
                  <label className="form-label">Message</label>
                  <textarea
                    className="form-control"
                    name="description"
                    rows="6"
                    required
                  />
                </div>
                <div className="col-12">
                  <label className="form-label">Attachment (optional)</label>
                  <SupportFileAttachment
                    value={attachmentString}
                    onChange={(value) => {
                      attachmentRef.current = value;
                      setAttachmentString(value);
                    }}
                    inputId="StudentNewTicketAttach"
                    disabled={loading}
                  />
                </div>
                <div className="col-12 text-end">
                  <button
                    type="submit"
                    className="button button-primary"
                    disabled={loading}
                  >
                    {loading ? "Submitting..." : "Submit ticket"}
                  </button>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
      </>
    </StudentSupportParentGuard>
  );
}

export default StudentSupportNewTicket;

